module.exports = __webpack_public_path__ + "img/8M7DqBb.3e1ce43b.png";